import { getConcessionType } from "@/helpers/service/api/concession";
import { getCommercialType } from "@/helpers/service/api/commercial";
import { getGoodsPackageListService } from "@/helpers/service/api/set";

export const shopTypeEnum = {
  "concession": getConcessionType,
  "commercial": getCommercialType,
  "goodsPackage": getGoodsPackageListService,
};
export const shopTypeListEnum = {
  "concession": "concessionList",
  "commercial": "commercialList",
  "goodsPackage": "goodsPackageList"
};
